import {Vue} from 'vue-property-decorator';

// TODO: fix this file so these rules don't need to be disabled
/* tslint:disable:max-classes-per-file */
/* tslint:disable:class-name */

export abstract class slideOutChatContainer extends Vue {
    public abstract showChat(): void;
    public abstract showUsers(): void;
    public abstract toggleView(): void;
}

export abstract class dropdownToggle extends Vue {
    public abstract toggle(): void;
}
